import X from '@/react/libraries/MultiLayerDropdown/';


export default function MultiLayerDropdown(props) {
	return <X {...props} />
}
